module.exports = ".container {\n  margin-top: 20px;\n}\n"